export function RowTwoIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <g id="Icon" transform="translate(-6426 2860)">
        <g
          id="Rectangle_14690"
          data-name="Rectangle 14690"
          transform="translate(6426 -2860)"
          fill="#fff"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_49811"
          data-name="Path 49811"
          d="M75,2987v16m-3.733-16h7.467a6.566,6.566,0,0,1,2.811.293,2.606,2.606,0,0,1,1.165,1.164,6.613,6.613,0,0,1,.291,2.809v7.467a6.613,6.613,0,0,1-.291,2.809,2.606,2.606,0,0,1-1.165,1.164,6.566,6.566,0,0,1-2.811.293H71.267a6.566,6.566,0,0,1-2.811-.293,2.606,2.606,0,0,1-1.165-1.164,6.613,6.613,0,0,1-.291-2.809v-7.467a6.613,6.613,0,0,1,.291-2.809,2.606,2.606,0,0,1,1.165-1.164A6.566,6.566,0,0,1,71.267,2987Z"
          transform="translate(6363 -5843)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
    </svg>
  );
}
